import React from "react";

const CardNosotros = ({ image, title, description }) => {
  return (
    <div className="max-w-md bg-blanco border border-gris-oscuro rounded-2xl shadow-lg overflow-hidden transform transition duration-300 hover:scale-105 hover:shadow-2xl hover:border-oro">
    <img src={image} alt={title} className="w-full h-52 object-cover" />
    <div className="p-6 text-center">
      <h3 className="text-xl font-bold text-azul">{title}</h3>
      <p className="text-gris-oscuro mt-3 text-justify">{description}</p>
    </div>
  </div>
  );
};

export default CardNosotros;
